export default "__VITE_ASSET__bfb40d8a__"